import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge.js";
import moment from "moment";
import apiService from "apiService";
import data from "./villageBorder";
HighchartsMore(Highcharts);
solidGauge(Highcharts);
const CaraBayar = ({tahun}) => {
  const [date, setdate] = useState({
    frDate: moment().startOf("year").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  });
  const [graph, setgraph] = useState({
    data: null,
    total: 0,
  });
  const [payments, setpayments] = useState(null);
  useEffect(() => {
    getKunjungan();
  }, [tahun]);

  const getKunjungan = async (e) => {
    let param = {
      puskesmas_id: "DINAS",
      frDate: moment([tahun]).startOf("year").format("YYYY-MM-DD"),
      enDate: moment([tahun]).endOf("year").format("YYYY-MM-DD"),
    };
    const res = await apiService.post("dashboard/visit_payment_dinas", param);
    if (res.code === 200) {
      let output = groupBy(res.data, "group");
      delete output.null;
      let seriesTotal = [];
      Object.values(output).forEach((val) => {
        seriesTotal.push(val.reduce((a, b) => a + b, 0));
      });
      let TotalPayment = seriesTotal.reduce((a, b) => a + b, 0);
      setgraph({
        data: output,
        total: TotalPayment,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  const groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x.count);
      return rv;
    }, {});
  };

  const [gaught, setgaught] = useState({
    chart: {
      height: 150,
    },
    colors: ['#ff910e'],

    title: {
      text: null,
      style: {
        fontSize: "14px",
      },
      verticalAlign: "bottom",
    },

    // tooltip: {
    //   borderWidth: 0,
    //   backgroundColor: "none",
    //   shadow: false,
    //   style: {
    //     fontSize: "16px",
    //   },
    //   valueSuffix: "%",
    //   pointFormat:
    //     '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
    //   positioner: function (labelWidth) {
    //     return {
    //       x: (this.chart.chartWidth - labelWidth) / 2,
    //       y: this.chart.plotHeight / 2 + 15,
    //     };
    //   },
    // },

    pane: {
      startAngle: 0,
      endAngle: 360,
      center: ["50%", "50%"],
      size: "100%",
      background: null,
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: true,
          borderRadius: 2,
          borderWidth: 0,
          y: -12,
          shape: "callout",
          format: "{y} %",
        },
        linecap: "round",
        stickyTracking: false,
        rounded: false,
      },
    },

    series: [
      {
        type: "solidgauge",
        name: "-",
        data: [0],
        size: 100,
        center: [40, 50],
      },
    ],
  });
  useEffect(() => {
    if (graph.data) {
      GenerateHightChart();
    }
  }, [graph.data]);
  const GenerateHightChart = () => {
    if (graph.data) {
      let element = [];
      let arr = graph.data;
      for (let property in arr) {
        let value = arr[property].reduce((a, b) => a + b, 0);
        let Persen = parseFloat(((value / graph.total) * 100).toFixed(2));
        let chart = {
          ...gaught,
          series: [
            {
              type: "solidgauge",
              name: property,
              data: [Persen],
              size: 100,
              center: [40, 50],
            },
          ],
          title: {
            text: property,
            style: {
              fontSize: "14px",
            },
            verticalAlign: "bottom",
          },
        };
        element.push(
          <div className="col-md-3" key={property}>
            <HighchartsReact highcharts={Highcharts} options={chart} />
          </div>
        );
      }
      // return (
      //   <div className="col-md-3">
      //     <HighchartsReact highcharts={Highcharts} options={chart} />{" "}
      //   </div>
      // );
      return element;
    } else {
      return <div></div>;
    }
  };

  return <div className="row col-md-12">{GenerateHightChart()}</div>;
};

export default CaraBayar;
